import React from 'react'

import SearchFilter, {SearchFilterProps} from './SearchFilter'

type ContextParamsSearchFilterProps = Omit<SearchFilterProps, 'filterKey' | 'isSpontanSearch'>

// props are forwarded as they come from the dropdown, there is nothing to default here
// eslint-disable-next-line react/require-default-props
const ContextParamsSearchFilter: React.FC<ContextParamsSearchFilterProps> = props => (
  <SearchFilter isSpontanSearch filterKey="search.contextParameters.value" {...props} />
)

export default ContextParamsSearchFilter
